import Cookies from 'js-cookie';

import { ENV_STAGES } from '../constants/ApiConstants';
import { currentHostName } from '@amzn/rangoli-seller-desktop-async-call-wrapper/src/index';


export interface PlatformCookies {
  ubidtacbin: string;
}

export function getPlatformCookie(): PlatformCookies | null {
  let X_TACBIN: string;
  if (currentHostName === ENV_STAGES.PROD || currentHostName === ENV_STAGES.GAMMA ) {
    X_TACBIN = 'x-acbin';
  } 
  else {
    X_TACBIN = 'x-tacbin';
  }
  let x_tacbin = localStorage.getItem(X_TACBIN);
  if (x_tacbin == null) {
    x_tacbin = Cookies.get(X_TACBIN) ?? null;
    if (x_tacbin != null) {
      localStorage.setItem('x-tacbin', x_tacbin);
    }
  }
  if (x_tacbin != null) {
    return {
      ubidtacbin: x_tacbin,
    };
  }
  return null;
}
